// extracted by mini-css-extract-plugin
export default {"newFlowButton":"Integrate_newFlowButton__jdi6e","newFlowButtonPopover":"Integrate_newFlowButtonPopover__2d0BH"};